import HorizontalScroll from '~/components/HorizontalScroll';
import { PRODUCT_TYPE_E_COUPON } from '~/domains/e-coupon/constants';
import ECouponProductCard from '~/domains/products/components/ECouponProductCard';
import ProductCard from '~/domains/products/components/ProductCard';
import { useSimilarProducts } from '~/domains/products/queries';
import type { OAISchema } from '~/types/openapi';
import { changedByFontScale } from '~/utils/fontScale';

import RecentlyViewedECouponProductCard from './RecentlyViewedECouponProductCard';
import RecentlyViewedProductCard from './RecentlyViewedProductCard';

type Props = {
  selectedProduct?: OAISchema['MarketSelectProductResponseV2'];
  offerId?: number;
};

const SimilarProducts = ({ selectedProduct, offerId }: Props) => {
  const { data: products = [], isLoading } = useSimilarProducts(offerId);

  if (isLoading || !selectedProduct) {
    return null;
  }

  return (
    <HorizontalScroll
      itemViewportWidth={changedByFontScale() ? 41 : 36}
      gap={16}
      key={offerId}
    >
      {selectedProduct?.productType === PRODUCT_TYPE_E_COUPON ? (
        <RecentlyViewedECouponProductCard
          key={selectedProduct.offerId}
          {...selectedProduct}
          plusMembershipFullBadge
          reverseCouponDiscountedPrice
          eventOption={{ detailedPlaceMent: '홈/최근본상품의 연관상품 추천' }}
        />
      ) : (
        <RecentlyViewedProductCard
          key={selectedProduct.offerId}
          {...selectedProduct}
          plusMembershipFullBadge
          reverseCouponDiscountedPrice
          eventOption={{ detailedPlaceMent: '홈/최근본상품의 연관상품 추천' }}
        />
      )}

      {products.map((product) => {
        if (product.productType === PRODUCT_TYPE_E_COUPON) {
          return (
            <ECouponProductCard
              key={product.offerId}
              {...product}
              plusMembershipFullBadge
              reverseCouponDiscountedPrice
              eventOption={{
                detailedPlaceMent: '홈/최근본상품의 연관상품 추천',
              }}
            />
          );
        }
        return (
          <ProductCard
            key={product.offerId}
            {...product}
            plusMembershipFullBadge
            reverseCouponDiscountedPrice
            eventOption={{
              detailedPlaceMent: '홈/최근본상품의 연관상품 추천',
            }}
          />
        );
      })}
    </HorizontalScroll>
  );
};

export default SimilarProducts;
